import React from 'react'
import { Heading, HeadingProps } from '@chakra-ui/react'

const CardFormTitle: React.FC<HeadingProps> = ({ children, ...props }) => {
  return (
    <Heading as="h3" fontSize="20px" py={2} {...props}>
      {children}
    </Heading>
  )
}

export default CardFormTitle
